import { Fragment, FunctionalComponent, RefObject, createRef, h } from 'preact';
import { Tab, TabList, TabPanel, useTabs } from '../../components/Tabs';

import PurposesList from '../../components/PurposesList';
import { TAB_VIEW } from '../../enums';
import VendorsList from '../../components/VendorsList';
import { isTcfLabels } from '@usercentrics/cmp-browser-sdk';
import { memo } from 'preact/compat';
import { useEffect } from 'preact/hooks';
import { useSettingsContext } from '../../contexts/SettingsContext';

type Props = {
  scrollerRef?: RefObject<HTMLDivElement> | undefined;
};

const TCFTabs: FunctionalComponent<Props> = ({ scrollerRef }) => {
  const { labels } = useSettingsContext();
  const { selected, select } = useTabs();

  const initialTab = TAB_VIEW.CATEGORIES_PURPOSES;

  const stickyRef = createRef();

  useEffect(() => {
    if (!selected) {
      select(initialTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isTcfLabels(labels)) {
    return null;
  }

  return (
    <Fragment>
      <TabList ariaLabel="SettingsTabs" ref={stickyRef}>
        <Tab
          ariaControls="uc-panel-purposes"
          id={`${labels.secondLayer.purposesTab}-id`}
          ariaLabel={labels.secondLayer.purposesTab}
          forPanel={TAB_VIEW.CATEGORIES_PURPOSES}
          testid="uc-tab-purposes"
        >
          {labels.secondLayer.purposesTab}
        </Tab>
        <Tab
          ariaControls="uc-panel-vendors"
          id={`${labels.secondLayer.vendorsTab}-id`}
          ariaLabel={labels.secondLayer.vendorsTab}
          forPanel={TAB_VIEW.SERVICES_VENDORS}
          testid="uc-tab-vendors"
        >
          {labels.secondLayer.vendorsTab}
        </Tab>
      </TabList>
      <TabPanel
        id={TAB_VIEW.CATEGORIES_PURPOSES}
        testid="uc-panel-purposes"
        ariaLabelledBy={`${labels.secondLayer.purposesTab}-id`}
      >
        <PurposesList
          titleAriaLevel={2}
          ref={scrollerRef}
          stickyRef={stickyRef}
          categoriesTitle={labels.titles.nonIabPurposes}
          featuresTitle={labels.vendor.features}
          isVisible={selected === TAB_VIEW.CATEGORIES_PURPOSES}
          purposesTitle={labels.vendor.purposes}
          useInlineToggle={false} // Should be always FALSE for TCF Second Layer
          useFromStackOnly={false} // Should be always FALSE for TCF Second Layer
        />
      </TabPanel>
      <TabPanel
        id={TAB_VIEW.SERVICES_VENDORS}
        testid="uc-panel-vendors"
        ariaLabelledBy={`${labels.secondLayer.vendorsTab}-id`}
      >
        <VendorsList
          titleAriaLevel={2}
          ref={scrollerRef}
          stickyRef={stickyRef}
          controllerIdLabel={labels.general.controllerId}
          isVisible={selected === TAB_VIEW.SERVICES_VENDORS}
          vendorTitle={labels.titles.iabVendors}
          serviceTitle={labels.titles.nonIabVendors}
        />
      </TabPanel>
    </Fragment>
  );
};

export default memo(TCFTabs);
